<!--
 * @Author: pluto.guo 66291979@qq.com
 * @Date: 2024-12-11 14:56:17
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-03-03 19:22:13
 * @FilePath: /lobby/src/views/DepositViewForET.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div
    v-if="!showIfram"
    class="deposit"
    :style="
      checkShowAPPDownloadBanner
        ? 'padding-top: calc(var(--user-bar-height) * 2);'
        : 'padding-top: calc(var(--user-bar-height));'
    "
  >
    <div class="content" ref="contentRef">
      <!-- <div v-if="payStatus != ''" style="width: 100%; height: 1.5rem" /> -->
      <div class="title">
        <div class="left-text">
          <i class="bi bi-folder" style="color: #ceb45f; font-size: 0.4rem"></i>&nbsp;
          {{ $t('deposit.title') }}
        </div>
        <div @click="onClose" class="close_black" />
      </div>
      <div v-if="payStatus == 'PAY_SUCCESS' || payStatus == 2" class="dw_qr t_center">
        <h2 style="color: #009944">
          {{ formatMoney(payAmount) }} {{ unitConversion(balance.currencyAlias) }}
        </h2>
        <p>{{ $t('deposit.success') }}</p>
        <div class="btn_dw_yellow btn_100" @click="onClose">Play Now</div>
      </div>
      <div v-else-if="payStatus == 'PAY_PADING' || payStatus == 1" class="dw_qr t_center">
        <p>{{ $t('message.padding') }}</p>
        <p>{{ $t('message.paddingtips') }}</p>
        <div class="btn_dw_grey btn_100">
          {{ $t('deposit.progress', { value: progress }) }}
        </div>
      </div>
      <div v-else class="while-card">
        <select-pay-methods-component
          @select="onSelectBank"
          :selectBank="selectBank"
          from="deposit"
        />
        <div style="width: 100%; height: 0.01rem; background: #bec3c7" />
        <select-deposit-amount-component
          :inputAmount="inputAmount"
          :rechargeConfig="rechargeConfig"
          @select="onSelectAnount"
        />
        <input-deposit-amount-component
          :country="country"
          :inputAmount="inputAmount"
          :inputType="inputType"
          :selectBank="selectBank"
          @focus="onFocus"
          @blur="onBlur"
          @input="onInput"
        />
        <div class="error-message">
          <i v-if="errMsg && errMsg.length > 0" class="bi bi-x-circle-fill">&nbsp;</i>
          {{ errMsg }}
        </div>
      </div>
      <!-- <div
        v-if="payStatus == ''"
        :class="`${btnState == 0 ? 'btn_dw_yellow' : 'btn_dw_grey'} btn_90`"
        @click="onDeposit"
      >
        <div style="text-align: center">
          {{ $t('deposit.recharge') }}
          {{ formatMoney(removeThousandSeparatorWithDecimal(inputAmount)) }}
          {{ balance.currencyAlias }}
        </div>
        <div v-if="bonusReward > 0" class="tag">Bonus&nbsp;{{ bonusReward }}</div>
      </div> -->
      <div class="deposit-button" @click="onDeposit" v-if="payStatus == ''">
        <div class="deposit-amount">
          {{ $t('deposit.recharge') }}
          {{ formatMoney(removeThousandSeparatorWithDecimal(inputAmount)) }}
          {{ balance.currencyAlias }}
        </div>
        <div class="bottom-gradient" v-if="bonusReward > 0">Gift {{ bonusReward }} Bonus</div>
      </div>
      <div style="height: 0.8rem"></div>
      <van-popup v-model:show="isShowFailTips" class="tips_popup" position="center">
        <div v-if="isNotBalance" class="dw_popup">
          <span>
            <div class="close_black" @click="tryagain"></div>
          </span>
          <h2 />
          <h2>{{ $t('deposit.Insufficient') }}</h2>
          <!-- <p>{{ qureypaymsg }}</p> -->
          <div class="btn_dw_yellow btn_100" @click="tryagain">
            {{ $t('message.tryAgain') }}
          </div>
        </div>
        <div
          v-else-if="isNotRegisterOrActive && selectBank.paymentMethod != 'cbebirr'"
          class="dw_popup"
        >
          <span>
            <div class="close_black" @click="tryagain"></div>
          </span>
          <h2 />
          <h2>{{ $t('deposit.notregister', { type: 'cbebirr' }) }}</h2>
          <!--  -->
          <div class="channel-item" @click="selectBankAndDeposit(cbebirr[0])">
            <!-- {{ cbebirr[0].payChannel }} -->
            {{ formatPayChannelName(cbebirr[0]) }}
          </div>
        </div>
        <div
          v-else-if="isNotRegisterOrActive && selectBank.paymentMethod == 'cbebirr'"
          class="dw_popup"
        >
          <span>
            <div class="close_black" @click="tryagain"></div>
          </span>
          <h2 />
          <h2>{{ $t('deposit.notregister', { type: 'cbebirr' }) }}</h2>
          <!--  -->
          <div class="btn_dw_yellow btn_100" @click="selectBankAndDeposit">
            {{ $t('deposit.recharge') }}
          </div>
        </div>
        <div v-else class="dw_popup">
          <span>
            <div class="close_black" @click="tryagain"></div>
          </span>
          <p>{{ qureypaymsg }}</p>
          <div class="btn_dw_yellow btn_100" @click="tryagain">
            {{ $t('message.tryAgain') }}
          </div>
        </div>
      </van-popup>
      <van-popup v-model:show="isShowTips" class="tips_popup" position="center">
        <div class="dw_popup">
          <span>
            <div class="close_black" @click="isShowTips = false"></div>
          </span>
          <h2 style="font-weight: normal; font-family: DroidSans">
            TIPS<br />Recommend {{ getPayMentMethodStr(defaultType[0]) }}
          </h2>
          <!-- <div v-for="(channel, index) in recommendChannel" :key="index" class="channel-item"
            @click="selectBankAndDeposit(channel)">
            {{ formatPayChannelName(channel) }}
          </div> -->
          <div class="btn_dw_yellow border-radius btn_100" @click="onDeposit(false)">Deposit</div>
        </div>
      </van-popup>
    </div>
  </div>
  <iframe
    id="frame"
    v-else
    :src="iframUrl"
    style="width: 100%; height: 100vh"
    scrolling="no"
    frameborder="0"
  />
</template>

<script>
import { getLocalStorage, Key } from '@/common/localStorage'
import { REPORT_EVENT, reportGtag } from '@/common/mgtag'
import InputDepositAmountComponent from '@/components/deposit/InputDepositAmountComponent.vue'
import SelectDepositAmountComponent from '@/components/deposit/SelectDepositAmountComponent.vue'
import { BUS } from '@/event/EventCenter'
import { useDepositStore } from '@/stores/deposit'
import { useLobbyStore } from '@/stores/lobby'
import { useUserStore } from '@/stores/user'
import {
  formatMoney,
  removeThousandSeparatorWithDecimal,
  formatPayChannelName
} from '@/utils/helper'
import { mapActions, mapState } from 'pinia'
import { closeToast, showLoadingToast } from 'vant'
import SelectPayMethodsComponent from '@/components/deposit/SelectPayMethodsComponent.vue'

export default {
  components: {
    SelectDepositAmountComponent,
    InputDepositAmountComponent,
    SelectPayMethodsComponent
  },
  props: {
    isInGame: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: true,
      inputType: 'text',
      inputAmount: '',
      amountObj: {},
      isFocus: false,
      isShowTips: false,
      select: -1,
      errMsg: '',
      bonusReward: 0,
      rechargeCount: 0,
      rechargeConfig: {},
      selectBank: {},
      defaultType: [],
      telebirr: [],
      cbebirr: [],
      mpesa: [],
      other: [],
      recommendChannel: [],
      btnState: 2,
      payStatus: '',
      payAmount: 0,
      qureypaymsg: 'Unknown',
      showIfram: false,
      iframUrl: '',
      isNotRegisterOrActive: false,
      isNotBalance: false,
      statusTimer: null,
      progress: 30
    }
  },
  computed: {
    ...mapState(useUserStore, ['country', 'userInfo', 'balance']),
    ...mapState(useLobbyStore, ['hasStickyBanner', 'checkShowAPPDownloadBanner']),
    isShowFailTips() {
      return this.payStatus == 'PAY_INVALID' || this.payStatus == 3
    }
  },
  watch: {
    rechargeConfig(val) {
      if (val.id) {
        this.mathBonus()
      }
    },
    selectBank(val) {
      if (val.id) {
        this.onInput({ target: { value: this.inputAmount } })
      }
    },
    inputAmount(val) {
      if (val > 0) {
        this.mathBonus()
      }
    },
    payStatus(val, oldval) {
      if (val != oldval) {
        console.log('payStatus', val, oldval)
        this.scrollToTop()
      }
    }
  },
  mounted() {
    // this.$bus.$emit(BUS.FULL_SCREEN, false)
    this.depositActivity().then((r) => {
      console.log('depositActivity', r)
      this.rechargeCount = r.rechargeCount
      this.rechargeConfig = r.config
    })
    this.$bus.$on(BUS.HIDE_DEPOSIT_IN_GAME, (res) => {
      this.showIfram = false
      this.iframUrl = ''
      this.$bus.$emit(BUS.FULL_SCREEN, false)
      this.$bus.$emit(BUS.SHOW_GAME_FOOTER, true)
      this.payStatus = res.status
      this.payAmount = res.amount
      this.qureypaymsg = res.msg
      this.parseErrorTips(res.msg)
      closeToast()
    })
    this.payStatus = ''
    this.btnState = 0
    this.scrollToTop()
  },
  methods: {
    formatMoney,
    removeThousandSeparatorWithDecimal,
    formatPayChannelName,
    ...mapActions(useDepositStore, {
      depositActivity: 'depositActivity',
      createOrder: 'createOrder',
      queryPay: 'queryPay'
    }),
    scrollToTop() {
      this.$nextTick(() => {
        this.$refs.contentRef.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        })
        setTimeout(() => {
          // 添加偏移量
          this.$refs.contentRef.scrollTop -= 100
          console.log('Scrolled to top with offset')
        }, 500)
      })
    },
    parseErrorTips(errMsg) {
      const notActivatedErrors = [
        'UNAUTHORIZED',
        'Failed while trying to initiate direct charges',
        'This customer did not active Credit Pay service',
        'Sorry, the account is not registered. Please create account first.'
      ]
      const insufficientBalanceErrors = [
        'Sorry! your account balance is insufficient and the requested amount is  above your eligible credit limit.',
        'Balance insufficient.'
      ]
      if (notActivatedErrors.indexOf(errMsg) !== -1) {
        // Handle not activated or not registered error
        console.log('Customer has not activated Credit Pay service.')
        this.isNotRegisterOrActive = true
        this.isNotBalance = false
      } else if (insufficientBalanceErrors.indexOf(errMsg) !== -1) {
        // Handle insufficient balance error
        console.log('Insufficient balance in the customer account.')
        this.isNotBalance = true
        this.isNotRegisterOrActive = false
      } else {
        // Handle other errors
        console.log('Other error:', errMsg)
        this.isNotRegisterOrActive = false
        this.isNotBalance = false
      }
    },
    getPayMentMethodStr(type) {
      switch (type) {
        case 'cbebirr':
          return 'CBE birr'
        case 'telebirr':
          return 'Telebirr'
        case 'mpesa':
          return 'Mpesa'
        default:
          return type
      }
    },
    tryagain() {
      this.payStatus = ''
      this.btnState = 0
    },
    selectBankAndDeposit(channel = this.cbebirr.find((item) => item.payChannel == 'santimPay')) {
      this.onSelectBank({ channel })
      this.onDeposit()
    },
    onDeposit(isDefault = true) {
      if (this.btnState == 0 && this.selectBank && this.selectBank.paymentMethod) {
        if (isDefault) {
          this.defaultType = this.checkPhonePaymentType(this.userInfo.phoneNumber)
          // this.defaultType = this.checkPhonePaymentType('0711111111')
          /**
           * 07 mpesa   09 telebirr
           *  07账号选择mpesa渠道充值时，不应该弹出引导去CBE充值的弹窗；
              09的账号选择tele充值时，也不会弹出引导去CBE充值额弹窗；

              07账号若选择CBE充值时，不会弹出引导去其他地方充值的弹窗；
              09账号若选择CBE充值时，不会弹出引导去其他地方充值的弹窗；

              07和09账号若选择other充值时，不会弹出引导去其他地方充值的弹窗；

              07账号选择tele充值时，会弹出引导去CBE的弹窗，若CBE充值渠道关闭，则弹出引导去mpesa的弹窗；
              09账号选择mpesa充值时，会先弹出引导去tele的弹窗，若tele充值渠道关闭，则弹出引导去CBE的弹窗；
           */
          console.log('defaultType', this.defaultType)
          const selectBank = this.selectBank.paymentMethod
          //other规则是跳三方，包含了以上三种paymentMethod，所以排除other
          const isOther = this.selectBank.routing !== 'direct'
          if (this.defaultType[0] == 'mpesa') {
            this.recommendChannel = this.mpesa
            if (selectBank === 'telebirr' && !isOther) {
              if (this.cbebirr && this.cbebirr.length > 0) {
                this.defaultType[0] = 'cbebirr'
                this.recommendChannel = this.cbebirr
                this.isShowTips = true
                return
              } else if (this.mpesa && this.mpesa.length > 0) {
                this.defaultType[0] = 'mpesa'
                this.recommendChannel = this.mpesa
                this.isShowTips = true
                return
              } else if (this.other && this.other.length > 0) {
                this.defaultType[0] = 'Other'
                this.recommendChannel = this.other
                this.isShowTips = true
                return
              } else {
                this.isShowTips = false
              }
            } else {
              this.isShowTips = false
            }
          }
          if (this.defaultType[0] == 'telebirr') {
            this.recommendChannel = this.telebirr
            if (selectBank === 'mpesa' && !isOther) {
              if (this.telebirr && this.telebirr.length > 0) {
                this.defaultType[0] = 'telebirr'
                this.recommendChannel = this.telebirr
                this.isShowTips = true
                return
              } else if (this.cbebirr && this.cbebirr.length > 0) {
                this.defaultType[0] = 'cbebirr'
                this.recommendChannel = this.cbebirr
                this.isShowTips = true
                return
              } else if (this.other && this.other.length > 0) {
                this.defaultType[0] = 'Other'
                this.recommendChannel = this.other
                this.isShowTips = true
                return
              } else {
                this.isShowTips = false
              }
            } else {
              this.isShowTips = false
            }
          }
        }
        showLoadingToast({
          message: '',
          forbidClick: true,
          duration: 60000
        })
        //调用充值api
        console.log('onDeposit', this.selectBank, 'selectamount', this.inputAmount)
        this.createOrder(
          {
            fee: this.removeThousandSeparatorWithDecimal(this.inputAmount),
            // 直冲不传payChannel(按照产品需求隐藏显示),走服务端随机逻辑
            payChannel: this.selectBank.routing == 'direct' ? '' : this.selectBank.payChannel
            // rechargeRecommendId: this.amountObj.id
          },
          this.userInfo.username,
          this.selectBank.paymentMethod,
          '',
          this.selectBank.routing
        ).then(({ response, id }) => {
          console.log('createOrder', response, id)
          this.queryOrder(id)
          if (this.selectBank.routing == 'direct') {
            // 直冲
            this.payStatus = 'PAY_PADING'
            closeToast()
            this.progress = 30
            let interval = setInterval(() => {
              if (this.progress > 0) {
                this.progress--
              } else {
                clearInterval(interval)
              }
            }, 1000)
            // setTimeout(() => {
            //   closeToast()
            // }, 30000)
          } else if (this.selectBank.routing == 'redirect') {
            // 重定向
            if (this.selectBank.redirectType && this.selectBank.redirectType == 'c_t') {
              window.location.href = response.payUrl
            } else if (this.selectBank.redirectType && this.selectBank.redirectType == 'n_t') {
              window.open(response.payUrl, '_blank') // 在新标签页中打开 URL
            } else {
              this.showIfram = true
              this.iframUrl = response.payUrl
              this.$bus.$emit(BUS.FULL_SCREEN, true)
              this.$bus.$emit(BUS.SHOW_GAME_FOOTER, false)
              this.payStatus = 'PAY_PADING'
              closeToast()
            }
          } else {
            setTimeout(() => {
              closeToast()
            }, 3000)
          }
        })
      }
    },
    queryOrder(id) {
      clearTimeout(this.statusTimer)
      this.queryPay(id).then((r) => {
        console.log('status: ====>>>>', status)
        if (r.status == 1) {
          this.statusTimer = setTimeout(() => {
            this.queryOrder(id)
          }, 30000)
        } else if (r.status == 3) {
          this.$bus.$emit(BUS.HIDE_DEPOSIT_IN_GAME, r)
        }
      })
    },
    checkPhonePaymentType(phoneNumber) {
      // 移除所有非数字字符
      const cleanNumber = phoneNumber.replace(/\D/g, '')

      // CBE birr 支持所有号段
      const cbeSupported = true

      // 检查 M-pesa (Safaricom) 号段
      const isMpesa = /^07\d{8}$/.test(cleanNumber) || /^7\d{8}$/.test(cleanNumber)

      // 检查 Telebirr (Ethio Telecom's) 号段
      const isTelebirr = /^09\d{8}$/.test(cleanNumber) || /^9\d{8}$/.test(cleanNumber)

      if (isTelebirr) {
        return ['telebirr', 'cbebirr', 'Other']
      } else if (isMpesa) {
        return ['mpesa', 'cbebirr', 'Other']
      } else if (cbeSupported) {
        return ['cbebirr', 'Other']
      } else {
        return ['Other']
      }
    },
    mathBonus() {
      const maximumReward = this.rechargeConfig.maximumReward
      const depositAmount = this.removeThousandSeparatorWithDecimal(this.inputAmount)
      const rewardPercent = this.rechargeConfig.rewardPercent
      if(depositAmount < this.rechargeConfig.minimumRecharge) {
        this.bonusReward = 0
        return
      }
      this.bonusReward = Math.min(maximumReward, Math.round(depositAmount * rewardPercent) / 100)
    },
    onSelectBank(bank) {
      console.log(bank)
      this.telebirr = bank.telebirr || this.telebirr
      this.cbebirr = bank.cbebirr || this.cbebirr
      this.mpesa = bank.mpesa || this.mpesa
      this.other = bank.other || this.other
      this.selectBank = bank.channel
      this.isShowTips = false
      this.btnState = this.selectBank.paymentMethod ? 0 : 1
    },
    onSelectAnount(amountObj) {
      console.log('amountObj', amountObj)
      this.amountObj = amountObj
      this.inputAmount = amountObj.amount
      this.onInput({ target: { value: this.inputAmount } })
    },
    onInput(e) {
      if (!this.selectBank.id || !e.target) {
        return
      }
      this.inputAmount = e.target.value || ''
      if (
        parseInt(e.target.value) >= Number(this.selectBank.minimum) &&
        parseInt(e.target.value) <= Number(this.selectBank.maximum)
      ) {
        this.errMsg = ''
        this.btnState = this.selectBank.paymentMethod ? 0 : 1
      } else {
        this.errMsg = this.$t(`deposit.inputLimit.${this.country}`, {
          minimum: formatMoney(this.selectBank.minimum, 0),
          maximum: formatMoney(this.selectBank.maximum, 0)
        })
        this.btnState = 2
      }
    },
    onFocus() {
      reportGtag(REPORT_EVENT.DEPOSIT.OPTIONAL_AMOUNT, 'click')
      this.isFocus = true
      this.select = -1
      this.inputAmount = this.removeThousandSeparatorWithDecimal(this.inputAmount)
      this.inputType = 'number'
    },
    onBlur() {
      this.isFocus = false
      this.inputType = 'text'
    },
    onClose() {
      const localFrom = getLocalStorage(Key.localFrom)
      if (localFrom && localFrom !== '') {
        window.location.href = localFrom
        return
      }
      this.show = false
      if (this.isInGame) {
        this.$bus.$emit(BUS.CLOSE_DEPOSIT_IN_GAME)
      } else {
        this.$router.replace('/')
        this.$bus.$emit(BUS.FULL_SCREEN, false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toast_success {
  width: 500px;
}

.deposit::-webkit-scrollbar {
  height: 0;
  /* 隐藏滚动条，但保持滚动功能 */
  display: none;
}

.deposit {
  display: flex;
  padding-bottom: var(--nav-bar-height);
  width: 100%;
  min-height: calc(100vh - var(--nav-bar-height) * 3);
  background: #e9eeef;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none;

  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    padding: 0.24rem 0.32rem 0 0.32rem;

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: auto;
      // padding: 2% 5%;

      .left-text {
        font-size: 0.28rem !important;
        display: inline;
        line-height: 0.8rem;
        font-weight: bold;
        margin: 0px;
        color: #000;
      }
    }

    .dw_qr {
      width: 100%;
      overflow: hidden;
      margin: 0.2rem 0 0.2rem;

      .t_center {
        text-align: center !important;

        .on_center {
          margin: 0 auto !important;
        }
      }

      p {
        color: #000;
        font-size: 0.24rem;
      }

      h2 {
        font-family: Oswald_Bold;
      }
    }

    .while-card {
      width: 94%;
      height: auto;
      background: #d6dce1;
      // background: linear-gradient(-55deg, #ededed, #e6e6e6, #dbdbdb, #ffffff);
      border-radius: 0.16rem;
      border: 0.02px solid #bec3c7;
      padding: 3%;
    }

    .deposit-button {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: flex-end;
      width: 5.56rem;
      height: 0.96rem;
      background: #ceb45f;
      box-shadow:
        0.02rem 0.02rem 0.02rem 0.02rem #aa884a,
        0.02rem 0.02rem 0.02rem 0.02rem #aa884a;
      border-radius: 0.08rem;
      margin: 0.19rem 0.42rem 0.65rem 0.42rem;

      .bottom-gradient {
        width: 5.44rem;
        height: 0.4rem;
        background: #e84c3d;
        border-radius: 0rem 0rem 0.08rem 0.08rem;
        margin-right: 0.06rem;
        margin-bottom: 0.06rem;
        margin-top: -0.06rem;
        font-family: Droid Sans;
        font-weight: bold;
        font-size: 0.24rem;
        color: #ffffff;
        text-align: center;
        line-height: 0.4rem;
      }

      .deposit-amount {
        display: flex;
        justify-content: center;
        align-content: center;
        width: 100%;
        height: 0.56rem;
        font-family: Droid Sans;
        font-weight: bold;
        line-height: 0.56rem;
        font-size: 0.3rem;
        color: #ffffff;
        text-align: center;
      }
    }

    .tips_popup {
      background-color: rgba($color: #000000, $alpha: 0);
      width: 100%;
      height: auto;
    }

    .dw_popup {
      width: 60%;
      height: auto;
      margin: 1rem auto;
      padding: 5%;
      border-radius: 0.16rem;
      overflow: hidden;
      background-color: #ecf0f1;
      color: #000000;
      font-size: 0.24rem;

      .channel-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80%;
        height: 0.6rem;
        margin-left: 10%;
        margin-top: 0.3rem;
        background: #ceb45f;
        color: #ffffff;
        border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
        border: 0.01rem solid #95a5a5;
        box-shadow:
          0.01rem 0.01rem 0.02rem 0.01rem #aa884a,
          inset 0.01rem 0.01rem 0rem 0.01rem #aa884a;
      }

      .selected-channel-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1.53rem;
        height: 0.46rem;
        background: #ffffff;
        border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
        border: 0.08rem solid #ceb45f;
      }
    }

    .dw_popup h2 {
      color: #000;
      margin: 0px;
      width: 100%;
      text-align: center;
      display: inline-block;
      position: relative;
      font-size: 0.24rem;
    }

    .dw_popup span {
      margin: 0.05rem -0.2rem -0.2rem 0;
      float: right;
      position: relative;
      z-index: 2;
    }

    .dw_popup p {
      font-size: 0.24rem;
      line-height: 0.32rem;
      margin: 0.2rem 0 0 0;
      color: #000;
      display: inline-block;
      text-align: center;
      width: 100%;
    }

    .dw_popup h3 {
      color: #000;
      font-size: 0.3rem;
      line-height: 0.4rem;
      margin: 0.1rem 0;
      text-align: center;
    }

    .error-message {
      margin-top: 0rem;
      font-weight: 400;
      font-size: 0.2rem;
      color: #e60012;
      line-height: 0.28rem;
      text-align: left;
      height: 0.2rem;
    }

    .tag {
      font-size: 0.2rem;
      line-height: 0.24rem;
      font-style: normal;
      text-transform: none;
      color: #fff;
      font-family: DroidSans;
      text-align: center;
      height: auto;
      width: max-content;
      background: #e84c3d;
      border-radius: 0.15rem 0 0 0.15rem;
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.4);
      float: right;
      position: relative;
      z-index: 4;
      display: inline;
      margin-top: -0.7rem;
      padding: 0.01rem 0.15rem;
    }

    .btn_dw_yellow,
    .btn_dw_grey {
      font-size: 0.24rem;
      line-height: 0.7rem;
      font-weight: normal;
      text-align: center;
      border-radius: 0.08rem;
      margin-top: 0.5rem;
    }

    .btn_dw_yellow {
      color: #fff;
      background-color: #ceb45f;
      border-top-width: 1px;
      border-bottom-width: 1px;
      border-top-style: solid;
      border-bottom-style: solid;
      border-bottom-color: #aa884a;
      border-top-color: #efe6ca;
      box-shadow: 0px 1px 0px 1px #aa884a;
      // overflow: hidden;
    }

    .border-radius {
      background: #ecf0f1;
      border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
      color: #aa884a;
    }

    .btn_dw_yellow:active {
      border-top-width: 4px;
      border-bottom-width: 0px;
      border-top-style: solid;
      border-bottom-style: solid;
      border-top-color: #aa884a;
    }

    .btn_dw_grey {
      color: #9b9b9b;
      background-color: #bbbebf;
      border-radius: 0.08rem;
      // overflow: hidden;
      border: 1px solid #8d8d8d;
    }

    .btn_90 {
      width: 90%;
      margin-left: 5%;
      line-height: 0.66rem;
      text-align: center;
    }

    .btn_100 {
      width: 100%;
      line-height: 0.66rem;
      text-align: center;
    }

    .close_black {
      display: block;
      width: 0.5rem;
      height: 0.05rem;
      border-radius: 0.025rem;
      background: #000;
      transform: rotate(45deg);
      // margin: 0 10%;
    }

    .close_black::after {
      content: '';
      display: block;
      width: 0.5rem;
      height: 0.05rem;
      border-radius: 0.025rem;
      background: #000;
      transform: rotate(-90deg);
    }
  }
}
</style>
